import React, { useState, useEffect } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import './App.css';
import Home from './pages/Home';
import Contato from './pages/Contato';
import Calendario from './pages/interno/calendario/Calendario';
import Urgencia from './pages/servicos/Urgencia';
import PaineisMonitoramento from './pages/interno/monitoramento/PaineisMonitoramento';
import Hub from './pages/interno/hub/Hub';
import Escala from './pages/interno/escala/Escala';
import EscalaHub from './pages/interno/escala/EscalaHub';
import EscalaEnfermagem from './pages/interno/escala/EscalaEnfermagem';
import InsumosPage from './pages/interno/escala/InsumosPage';
import RelatoriosPage from './pages/interno/escala/RelatoriosPage';
import Notify from './pages/interno/notificacoes/Notify';
import Login from './pages/Login';
import CalendarioExterno from './pages/Agenda';
import Blog from './pages/Blog';
import SaudeMental from './pages/servicos/SaudeMental';
import Seguranca from './pages/servicos/Seguranca';
import Maternidade from './pages/servicos/Maternidade';
import CCIH from './pages/servicos/CCIH';
import Hospitais from './pages/servicos/Hospitais';
import Assessoria from './pages/servicos/Assessoria';
import BoletinsInformativos from './components/BibliotecaSubhue/BoletinsInformativos';
import Plataforma from './pages/servicos/Plataforma';
import Atendimento from './pages/servicos/Atendimento';
import Guias from './pages/servicos/Guias';
import Cegonha from './pages/servicos/Cegonha';
import Ouvidoria from './pages/servicos/Ouvidoria';
import Register from './pages/Register';
import AdminVisualize from './pages/interno/administrador/AdminVisualize';
import Permissionador from './pages/interno/administrador/Permissionador';
import CalendarForm from './pages/interno/calendario/CalendarForm';
import Monitoramento from './pages/interno/monitoramento/Monitoramento';
import MonitoramentoSUBHUE from './pages/interno/IndicadoresSUBHUE/MonitoramentoSUBHUE';
import NotifyHub from './pages/servicos/NotesHub';
import NotesAvaliation from './pages/interno/notificacoes/NotesAvaliation';
import NotesLogin from './pages/NoteLogin';
import ClassInvForm from './components/ClassInvForm';
import {
	requestUnits,
	requestPublics,
	requestBibliotecaRepositorios,
} from '../src/services/requests';
import CardBiblioteca from './components/CardBiblioteca';
import AtencaoDomiciliar from './components/BibliotecaSubhue/AtencaoDomiciliar';
import HospitaisUrgencias from './components/BibliotecaSubhue/HospitaisUrgencias';
import MaternidadeHospitais from './components/BibliotecaSubhue/MaternidadesHospitais';
import GestaoBiblioteca from './pages/interno/gestaoBiblioteca/GestaoBiblioteca';
import GestaoArquivos from './pages/interno/gestaoBiblioteca/GestaoArquivos';
import GestaoEditArquivos from './pages/interno/gestaoBiblioteca/GestaoEditArquivos';
import SinanHome from './pages/interno/sinan/SinanHome';
import SinanCreator from './pages/interno/sinan/SinanCreator';
import SafetyHuddleIframePage from './pages/interno/safetyHuddle/SafetyHuddleIframePage';
import AvcHub from './pages/interno/avc/AvcHub';
import AvcIframePage from './pages/interno/avc/AvcIframePage';
import NotFound from './components/NotFound';
import BibliotecaRepositorioPage from './pages/BibliotecaRepositorioPage';
import ScaleManager from './components/Escala Medica/ScaleManager';
import GerenciarProfissionais from './components/Escalas Utils/GerenciarProfissionais';
import Solicitacoes from './components/Escala Medica/Solicitacoes';
import { ESCALA_ENFERMAGEM_HABILITADA } from './utils/escalaFeatures';

import ParceriasCustom from './pages/interno/Parcerias/ParceriasCustom';
import Footer from './components/Footer';
import Cadastro from './pages/interno/administrador/Cadastro';

import Cookies from 'js-cookie';

const normalizeAccessValue = (value = '') =>
	String(value || '')
		.normalize('NFD')
		.replace(/[\u0300-\u036f]/g, '')
		.toLowerCase()
		.trim();

const AVC_SPECIAL_ALLOWED_FOR = [
	'subhue',
	'desenvolvedor',
	'smsrio',
	'sms rio',
	'sms',
];

const PrivateRoute = ({ element, allowedFor, requiredPermission }) => {
	try {
		const raw = Cookies.get('user');
		if (!raw)
			return (
				<Navigate
					to='/login'
					replace
				/>
			);
		const user = JSON.parse(raw);
		const userPermissions = Array.isArray(user?.permissao)
			? user.permissao
			: [user?.permissao].filter(Boolean);
		const hasRequiredPermission = Array.isArray(requiredPermission)
			? requiredPermission.some((permission) =>
					userPermissions.includes(permission),
				)
			: !requiredPermission || userPermissions.includes(requiredPermission);
		if (Array.isArray(allowedFor) && allowedFor.length > 0) {
			const allowedProfiles = allowedFor.map(normalizeAccessValue);
			const userProfiles = [
				user?.nome,
				user?.unidade,
				user?.cargo,
				...(Array.isArray(user?.permissao)
					? user.permissao
					: [user?.permissao].filter(Boolean)),
			].map(normalizeAccessValue);
			const hasAllowedProfile = userProfiles.some((profile) =>
				allowedProfiles.includes(profile),
			);
			if (!hasAllowedProfile && !hasRequiredPermission) {
				return <Navigate to='/hub' replace />;
			}
		} else if (!hasRequiredPermission) {
			return <Navigate to='/hub' replace />;
		}
		return element;
	} catch {
		return (
			<Navigate
				to='/login'
				replace
			/>
		);
	}
};

function App() {
	const [isLoading, setIsLoading] = useState(true);
	const location = useLocation();
	const [unidades, setUnidades] = useState([]);
	const [publics, setPublics] = useState([]);
	const [reposBiblioteca, setReposBiblioteca] = useState([]); // <- NOVO
	const secret = process.env.REACT_APP_SECRET;

	const request = async () => {
		const requestLog = await requestUnits();
		const requestPubs = await requestPublics();
		if (requestPubs) {
			setPublics(requestPubs);
		}
		if (requestLog) {
			setUnidades(requestLog);
		}
	};

	// busca repositórios da biblioteca quando necessário
	const requestBiblioteca = async () => {
		try {
			const repos = await requestBibliotecaRepositorios();
			if (Array.isArray(repos)) {
				setReposBiblioteca(repos);
			} else {
				setReposBiblioteca([]);
			}
		} catch (e) {
			console.error('Erro ao carregar repositórios da biblioteca:', e);
			setReposBiblioteca([]);
		}
	};

	const encryptName = (name) => {
		const encoded = btoa(name);
		return encoded;
	};

	useEffect(() => {
		request();

		// se estiver em qualquer rota que comece com /biblioteca, carrega os repositórios
		if (location.pathname.startsWith('/biblioteca')) {
			requestBiblioteca();
		}

		setIsLoading(true);
		const timer = setTimeout(() => {
			setIsLoading(false);
		}, 1000);

		return () => clearTimeout(timer);
	}, [location.pathname]);

	return (
		<div className='w-full max-w-full min-h-screen overflow-hidden '>
			<div className='flex-1'>
				{isLoading ? (
					<div className='loader'>
						<div
							className='flex justify-center min-h-screen content-center align-bottom items-baseline  w-full my-20'
							role='status'>
							<svg
								aria-hidden='true'
								className='w-8 h-8 text-gray-200 animate-spin mt-[100px]  fill-blue-600'
								viewBox='0 0 100 101'
								fill='none'
								xmlns='http://www.w3.org/2000/svg'>
								<path
									d='M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z'
									fill='currentColor'
								/>
								<path
									d='M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z'
									fill='currentFill'
								/>
							</svg>
							<span className='sr-only'>Loading...</span>
						</div>
					</div>
				) : (
					<Routes>
						<Route
							path='/'
							element={<Navigate to='/home' />}
						/>
						<Route
							path='home'
							element={<Home />}
						/>
						<Route
							path='agenda-eventos'
							element={<CalendarioExterno />}
						/>
						<Route
							path='contato'
							element={<Contato />}
						/>
						<Route
							path='calendario-interno'
							element={<PrivateRoute element={<Calendario />} />}
						/>
						<Route
							path='login'
							element={<Login />}
						/>
						<Route
							path='paineis-de-monitoramento'
							element={
								<PrivateRoute
									element={<PaineisMonitoramento />}
								/>
							}
						/>
						<Route
							path='hub'
							element={<PrivateRoute element={<Hub />} />}
						/>
						<Route
							path='escala'
							element={<PrivateRoute element={<EscalaHub />} />}
						/>
						<Route
							path='escala-medica'
							element={<PrivateRoute element={<Escala />} />}
						/>
						<Route
							path='escala-enfermagem'
							element={
								ESCALA_ENFERMAGEM_HABILITADA ? (
									<PrivateRoute element={<EscalaEnfermagem />} />
								) : (
									<Navigate to='/escala' replace />
								)
							}
						/>
						<Route
							path='insumos'
							element={<PrivateRoute element={<InsumosPage />} />}
						/>
						<Route
							path='escala-relatorios'
							element={<PrivateRoute element={<RelatoriosPage />} />}
						/>
						<Route
							path='/escala-gerenciamento'
							element={
								<PrivateRoute element={<ScaleManager />} />
							}
						/>
						<Route
							path='/escala-profissionais'
							element={
								<PrivateRoute
									element={<GerenciarProfissionais />}
								/>
							}
						/>
						<Route
							path='/escala-solicitacoes'
							element={
								<PrivateRoute element={<Solicitacoes />} />
							}
						/>
						<Route
							path='notificacoes'
							element={<PrivateRoute element={<Notify />} />}
						/>
						<Route
							path='register'
							element={<Register />}
						/>
						<Route
							path='cadastro'
							element={<PrivateRoute element={<Cadastro />} />}
						/>
						<Route
							path={
								'/assessoria-de-programas-de-desospitalizacao'
							}
							element={<Assessoria />}
						/>
						<Route
							path={'/seguranca-do-paciente'}
							element={<Seguranca />}
						/>
						<Route
							path={'/urgencia-e-emergencia'}
							element={<Urgencia />}
						/>
						<Route
							path={'/saude-mental'}
							element={<SaudeMental />}
						/>
						<Route
							path={'/notificacoes-login'}
							element={<NotesLogin />}
						/>
						<Route
							path={'/maternidade-e-pediatria'}
							element={<Maternidade />}
						/>
						<Route
							path={'/ccih'}
							element={<CCIH />}
						/>
						<Route
							path='/hospitais-gerais-especializados'
							element={<Hospitais />}
						/>
						<Route
							path={'/plataforma-de-ensino'}
							element={<Plataforma />}
						/>
						<Route
							path={'/atendimento'}
							element={<Atendimento />}
						/>
						<Route
							path={'/guias'}
							element={<Guias />}
						/>
						<Route
							path={'/monitoramento-leitos'}
							element={
								<PrivateRoute element={<Monitoramento />} />
							}
						/>
						<Route
							path={'/monitoramento-subhue'}
							element={
								<PrivateRoute
									element={<MonitoramentoSUBHUE />}
								/>
							}
						/>
						<Route
							path={'/cegonha'}
							element={<Cegonha />}
						/>
						<Route
							path={'/ouvidoria'}
							element={<Ouvidoria />}
						/>
						<Route
							path={'/admin-visualize'}
							element={
								<PrivateRoute element={<AdminVisualize />} />
							}
						/>
						<Route
							path={'/permissionador'}
							element={
								<PrivateRoute element={<Permissionador />} />
							}
						/>
						<Route
							path={'/blog'}
							element={<Blog />}
						/>
						<Route
							path={'/calendar-form'}
							element={
								<PrivateRoute element={<CalendarForm />} />
							}
						/>
						<Route
							path={'/hub-de-notificacoes'}
							element={<NotifyHub />}
						/>
						<Route
							path={'/notes-avaliation'}
							element={
								<PrivateRoute element={<NotesAvaliation />} />
							}
						/>
						<Route
							path={'/biblioteca-subhue'}
							element={<CardBiblioteca />}
						/>
						<Route
							path={'/boletins'}
							element={
								<PrivateRoute
									element={<BoletinsInformativos />}
								/>
							}
						/>
						<Route
							path={'/atencao-domiciliar'}
							element={
								<PrivateRoute element={<AtencaoDomiciliar />} />
							}
						/>
						<Route
							path={'/hospitais-urgencias-emergencias'}
							element={
								<PrivateRoute
									element={<HospitaisUrgencias />}
								/>
							}
						/>
						<Route
							path={'/maternidades-hospitais-pediatricos'}
							element={
								<PrivateRoute
									element={<MaternidadeHospitais />}
								/>
							}
						/>
						<Route
							path={'/gestao-biblioteca'}
							element={
								<PrivateRoute element={<GestaoBiblioteca />} />
							}
						/>
						<Route
							path={'/gestao-arquivos'}
							element={
								<PrivateRoute element={<GestaoArquivos />} />
							}
						/>
						<Route
							path={'/gestao-editar-arquivos/:id'}
							element={
								<PrivateRoute
									element={<GestaoEditArquivos />}
								/>
							}
						/>
						<Route
							path={'/sinan'}
							element={<PrivateRoute element={<SinanHome />} />}
						/>
						<Route
							path={'/sinan-ficha'}
							element={
								<PrivateRoute element={<SinanCreator />} />
							}
						/>
						<Route
							path={'/gestao-parcerias'}
							element={
								<PrivateRoute element={<ParceriasCustom />} />
							}
						/>
						<Route
							path={'/safety-huddle'}
							element={
								<PrivateRoute
									allowedFor={['desenvolvedor']}
									requiredPermission='SafetyHuddle'
									element={<SafetyHuddleIframePage />}
								/>
							}
						/>
						<Route
							path='/avc'
							element={
								<PrivateRoute
									allowedFor={AVC_SPECIAL_ALLOWED_FOR}
									requiredPermission='AVC'
									element={<AvcHub />}
								/>
							}
						/>
						<Route
							path='/avc/indicadores-angels'
							element={
								<PrivateRoute
									allowedFor={AVC_SPECIAL_ALLOWED_FOR}
									requiredPermission='AVC'
									element={
										<AvcIframePage
											title='Indicadores Angels'
											page='indicadores-angels'
										/>
									}
								/>
							}
						/>
						<Route
							path='/avc/acompanhamento'
							element={
								<PrivateRoute
									allowedFor={AVC_SPECIAL_ALLOWED_FOR}
									requiredPermission='AVC'
									element={
										<AvcIframePage
											title='Acompanhamento AVC'
											page='acompanhamento'
										/>
									}
								/>
							}
						/>
						<Route
							path='*'
							element={<NotFound />}
						/>
						<Route
							path={'/class-inv-form'}
							element={
								<PrivateRoute element={<ClassInvForm />} />
							}
						/>
						{/* Rotas dinâmicas geradas via map */}
						{publics && publics.length > 0 ? (
							publics.map((pub) => (
								<Route
									key={'blog' + pub.id}
									path={`/blog/${pub.id}`}
									element={<Blog />}
								/>
							))
						) : (
							<Route
								path='/blog/nenhuma noticia disponível'
								element={
									<div>Nenhuma noticia com esta url.</div>
								}
							/>
						)}
						{/* Rotas dinâmicas geradas via map */}
						{unidades && unidades.length > 0 ? (
							unidades.map((unidade) => (
								<Route
									key={unidade.id + 'tonc'}
									path={`/notificacoes/${encryptName(
										unidade.nome,
										secret,
									)}`}
									element={<Notify />}
								/>
							))
						) : (
							<Route
								path='/notificacoes/nenhuma-notificacao'
								element={
									<div>Nenhuma notificação disponível.</div>
								}
							/>
						)}
						<Route
							path={'/boletins-informativos'}
							element={
								<PrivateRoute
									element={<BoletinsInformativos />}
								/>
							}
						/>
						<Route
							path={'/atencao-domiciliar'}
							element={
								<PrivateRoute element={<AtencaoDomiciliar />} />
							}
						/>
						<Route
							path={'/hospitais-urgencias-emergencias'}
							element={
								<PrivateRoute
									element={<HospitaisUrgencias />}
								/>
							}
						/>
						<Route
							path={'/maternidades-hospitais-pediatricos'}
							element={
								<PrivateRoute
									element={<MaternidadeHospitais />}
								/>
							}
						/>
						<Route
							path={'/gestao-biblioteca'}
							element={
								<PrivateRoute element={<GestaoBiblioteca />} />
							}
						/>
						<Route
							path={'/gestao-arquivos'}
							element={
								<PrivateRoute element={<GestaoArquivos />} />
							}
						/>
						<Route
							path={'/gestao-editar-arquivos/:id'}
							element={
								<PrivateRoute
									element={<GestaoEditArquivos />}
								/>
							}
						/>
						<Route
							path={'/sinan'}
							element={<PrivateRoute element={<SinanHome />} />}
						/>
						<Route
							path={'/sinan-ficha'}
							element={
								<PrivateRoute element={<SinanCreator />} />
							}
						/>
						<Route
							path={'/gestao-parcerias'}
							element={
								<PrivateRoute element={<ParceriasCustom />} />
							}
						/>
						<Route
							path={'/safety-huddle'}
							element={
								<PrivateRoute
									allowedFor={['desenvolvedor']}
									requiredPermission='SafetyHuddle'
									element={<SafetyHuddleIframePage />}
								/>
							}
						/>
						<Route
							path='*'
							element={<NotFound />}
						/>
						<Route
							path={'/class-inv-form'}
							element={
								<PrivateRoute element={<ClassInvForm />} />
							}
						/>
						{/* Rotas dinâmicas geradas via map */}
						{reposBiblioteca.map((repo) => (
							<Route
								key={`biblioteca-repo-${repo.id}`}
								// exemplo: /biblioteca/1, /biblioteca/2, etc.
								path={`/biblioteca/${repo.id}`}
								element={
									<BibliotecaRepositorioPage
										repoId={repo.id}
									/>
								}
							/>
						))}
					</Routes>
				)}
			</div>
			<div className='bottom-0 w-full  items-end content-end'>
				<Footer />
			</div>
		</div>
	);
}
export default App;
